import React, { lazy } from 'react';

import { useAlert } from 'react-alert';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';

import { DashboardBody } from '../components/dashboard_body';
import { isLoggedIn } from '../utils/helpers';
import { SetUp } from './dashboard/setup';

const Dashboard = lazy(() => import("./dashboard/index"));
const Activities = lazy(() => import("./activities"));
const Wallet = lazy(() => import("./wallet"));
const MakePayment = lazy(() => import("./make-payment/make_payment"));

const SupportTicket = lazy(() => import("./support/support_ticket"));
const SupportDetail = lazy(() => import("./support/support_detail"));
const AddSupportTicket = lazy(() => import("./support/add_support_ticket"));

const Settings = lazy(() => import("./settings"));
const WhereToBuy = lazy(() => import("./shop/where_to_buy"));
const MerchantProducts = lazy(() => import("./shop/products"));
const BuyProducts = lazy(() => import("./shop/buy"));
const PaymentPage = lazy(() => import("./pay/pay"));

export const dashboardRoutes = [
    { path: "/dashboard", component: Dashboard },
    {
        path: "/activities",
        component: Activities,
    },
    {
        path: "/wallet",
        component: Wallet,
    },
    {
        path: "/payments",
        component: MakePayment,
    },

    {
        path: "/settings",
        component: Settings,
    },
    {
        path: "/support",
        component: SupportTicket,
    },
    {
        path: "/support/detail/:support_id",
        component: SupportDetail,
    },
    {
        path: "/support/create",
        component: AddSupportTicket,
    },
    {
        path: "/where-to-buy",
        component: WhereToBuy,
    },
    { path: "/merchant/:id/products", component: MerchantProducts },
    {
        path: "/buy/:product",
        component: BuyProducts,
    },
    {
        path: "/pay/:payment_id",
        component: PaymentPage,
    },
    {
        path: "/payment/requests",
        component: lazy(() => import("./payment_request/view-requests")),
    },
    {
        path: "/enjoy-now",
        component: lazy(() => import("./enjoy_now/enjoy_now_home"))
    },
    {
        path: "/enjoy-now/prequalify",
        component: lazy(() => import("./enjoy_now/enjoy_now_prequalify"))
    },
    {
        path: "/enjoy-now/requests",
        component: lazy(() => import("./enjoy_now/enjoy_now_credit_requests"))
    },
    {
        path: "/enjoy-now/:id/apply",
        component: lazy(() => import('./enjoy_now/enjoy_now_application'))
    },
    {
        path: "/enjoy-now/apply/:id",
        component: lazy(() => import('./enjoy_now/enjoy_now_apply'))
    },

];

export function MainPage() {
    const history = useHistory();
    const alert = useAlert();
    if (!isLoggedIn()) {
        localStorage.setItem(
            "redirect_intended",
            history.location.pathname + history.location.search
        );
        alert.info("Please login to proceed");
        return <Redirect to={"/login"} />;
    }
    return (
        <Switch>
            <Route exact path="/" component={SetUp} />
            <Route
                path={dashboardRoutes.map((v) => v.path)}
                component={DashboardRoute}
            />
        </Switch>
    );
}

const DashboardRoute = () => (
    <DashboardBody>
        <Switch>
            {dashboardRoutes.map((dR) => (
                <Route
                    key={dR.path}
                    path={dR.path}
                    exact
                    component={dR.component}
                />
            ))}
        </Switch>
    </DashboardBody>
);
